import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import { UserTranslationService } from '../../../services/user-translation/user-translation.service';

@Component({
  selector: 'app-default-header-dropdown-account',
  templateUrl: './default-header-dropdown-account.component.html',
})
export class DefaultHeaderDropdownAccountComponent implements OnInit {

  public userName = '';

  constructor(
    private router: Router,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    private userTranslationService: UserTranslationService,
  ) { }

  ngOnInit(): void {
    this.userName = this.storageSrv.getUserName();
  }

  logout() {
    this.localInterfaceSrv.logout()
      .then(() => {
        this.router.navigate(['/login/']);
      }).catch;
  }
}
